export const verificaAcrescimo = (value, tipoAcresDesc) => {
  let number = 0
  if (value && typeof value === 'string' && tipoAcresDesc === 'R$') {
    number = parseFloat(value.replace('R$', ''), 10)
  } else if (value && typeof value === 'string' && tipoAcresDesc === '%') {
    number = (parseFloat(value.replace('%', ''), 10) / 100)
  } else if (value) {
    number = parseFloat(value, 10)
  }
  return number
}

export const valorParaComparar = (value, number, tipoAcresDesc) => {
  let valorComparar = 0
  if (tipoAcresDesc === 'R$') {
    valorComparar = value + number
  } else if (number > 0) {
    valorComparar = number * value
  } else {
    valorComparar = value
  }
  return valorComparar
}

export const verificaDesconto = (value, valorComparar, tipoAcresDesc) => {
  let desc = 0
  if (typeof value === 'string' && tipoAcresDesc === 'R$') {
    desc = parseFloat(value.replace('R$', ''), 10)
  } else if (typeof value === 'string' && tipoAcresDesc === '%') {
    desc = (parseFloat(value.replace('%', ''), 10) / 100) * valorComparar
  } else {
    desc = value
  }
  return desc
}
